var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClubs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 9.25004C17.4043 9.25004 16.6865 9.39855 16.0329 9.64024C16.8677 8.61337 17.5 7.33438 17.5 5.81248C17.5 3.15462 15.0376 1 12 1C8.9624 1 6.5 3.15462 6.5 5.81248C6.5 7.33428 7.13227 8.61335 7.96712 9.64024C7.31347 9.39854 6.5957 9.25004 5.8125 9.25004C3.15462 9.25004 1 11.4047 1 14.0625C1 16.7204 3.15462 18.875 5.8125 18.875C8.20935 18.875 10.0053 17.5044 11.1599 16.2261C10.749 19.6785 9.53495 21.3399 7.875 23H16.125C14.4651 21.3401 13.251 19.6785 12.8401 16.2261C13.9946 17.5043 15.7906 18.875 18.1875 18.875C20.8454 18.875 23 16.7204 23 14.0625C23 11.4047 20.8454 9.25004 18.1875 9.25004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubs);
export default __webpack_public_path__ + "static/media/clubs.a24e68527782da992f6222af46bc8207.svg";
export { ForwardRef as ReactComponent };